<template>
    <div id="RoomsPage">
      <page-header icon="key-room">
        <template v-slot:title>НОМЕРА И ЦЕНЫ</template>
        <template v-slot:text>К УСЛУГАМ ОТДЫХАЮЩИХ КОМФОРТНЫЕ НОМЕРА ШЕСТИ КАТЕГОРИЙ</template>
      </page-header>

       <room-block  :room="[rooms[0]]"/>
       <page-header v-if="selectedRoom" margin-bottom="10"><template v-slot:title>НОМЕРА ДРУГИХ КАТЕГОРИЙ</template></page-header>
       <room-block  :room="[rooms[1]]"/>
       <room-block  :room="[rooms[2]]"/>
       <room-block  :room="[rooms[3]]"/>
       <room-block  :room="[rooms[4]]"/>
       <room-block  :room="[rooms[5]]"/>

    </div>
</template>

<script>



import RoomBlock from "@/hotel/RoomBlock";
import PageHeader from "@/components/PageHeader";
export default {
  name: 'RoomsPage',
  props:['selectedRoom'],
  components: {PageHeader, RoomBlock},
  data: () => ({
      rooms:['familyLux','comfortDBL','comfortTWIN','standard','studio','lux']
  }),
  mounted() {
      if(this.selectedRoom){
          let rooms = this.rooms
          let selectedIndex = rooms.indexOf(this.selectedRoom);
          var element = rooms[selectedIndex];
          rooms.splice(selectedIndex, 1);
          rooms.splice(0, 0, element);
          this.rooms = rooms

      }
  },
}
</script>

<style scoped>
  #RoomsPage{
    display: grid;
  }



</style>